var map = {
	"./01_zastava.svg": 9234,
	"./02_pgo.svg": 7391,
	"./03_np.svg": 3038,
	"./04_sekret.svg": 4621,
	"./05_chg.svg": 8994,
	"./06_dozor.svg": 1473,
	"./07_pn.svg": 8942,
	"./08_zasada.svg": 6587,
	"./09_tg.svg": 9197,
	"./10_pg.svg": 6183,
	"./11_stpn.svg": 7108,
	"./12_rlp.svg": 5664,
	"./13_prozhektor.svg": 3888,
	"./14_tsog.svg": 8789,
	"./15_dog.svg": 1395,
	"./16_bpla.svg": 1221,
	"./17_engineer.svg": 6666,
	"./18_mines.svg": 9288,
	"./19_wire.svg": 4572,
	"./20_stolb.svg": 2455,
	"./21_taynik.svg": 1500,
	"./22_kp.svg": 7660,
	"./23_med.svg": 3648,
	"./24_arrow_dir.svg": 3806,
	"./25_narushitel.svg": 5533,
	"./26_otdel.svg": 7911,
	"./27_vzvod.svg": 6085,
	"./28_rota.svg": 9299,
	"./29_post.svg": 1998,
	"./30_svyaz.svg": 2319,
	"./31_okop.svg": 2562,
	"./32_bridge.svg": 351,
	"./33_shtab.svg": 8523,
	"./34_arm.svg": 356,
	"./35_sanchast.svg": 6480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8913;